import { query } from 'firebase/firestore'
import { ArrayService } from './serviceLive'
import type { EmployeeUser } from '~/models/EmployeeUsers/EmployeeUser'

export class EmployeeUserService extends ArrayService<EmployeeUser> {
  constructor() {
    super('EmployeeUsers')
  }

  public listenForAll(): void {
    this.listen(query(this.collection))
  }
}
